import { CobranzasAxios, COMPANY } from './config'

export const postServices = async (data) => {
  const res = await CobranzasAxios.post(`/service/${COMPANY}`, data)
  return res.data
}

export const importServices = async (data) => {
  const res = await CobranzasAxios.post(`/service/import/${COMPANY}`, data)
  return res.data
}

export const getServices = async () => {
  const res = await CobranzasAxios.get(`/service/${COMPANY}`)
  return res.data
}

export const putServices = async (data, id) => {
  const res = await CobranzasAxios.put(`/service/${id}`, data)
  return res.data
}
